import { isObject, keys, set } from "lodash";
import { SearchSliderSettings } from "../inputs/settings/slider";
import firstCapitalCase from "../../../services/firstCapitalCase";

const transformWeatherValue = (value: any, objectKey: string) => {
    const settings = SearchSliderSettings[objectKey];
    if (settings.isTemperature) {
        let firstValue = value[0];
        let secondValue = value[1];
        if (settings.min == value[0]) {
            firstValue = null;
        }
        if (settings.max == value[1]) {
            secondValue = null;
        }
        if (firstValue == null && secondValue == null) {
            return undefined;
        }
        return [firstValue, secondValue];
    }
    if (settings.isFromSelectedValueUp) {
        if (settings.min == value) {
            return undefined;
        }
        return [value, null];
    } else {
        if (settings.max == value) {
            return undefined;
        }
        return [null, value];
    }
};

const transformValue = (value: any, category: string, objectKey: string) => {
    if (!value) {
        return undefined;
    }
    if (category === "weather" && objectKey !== "rainseason") {
        return transformWeatherValue(value, objectKey);
    }
    const num = Number(value);
    if (!isNaN(num)) {
        return num;
    } else {
        return value;
    }
};

const getSearchCategory = (category: string, objectKey: string) => {
    let categories = [];
    switch (category) {
        case "weather":
            categories.push("weather");
            if (["tmax", "wet"].includes(objectKey)) {
                categories.push("essentials");
            }
            break;
        case "beach":
        case "beachSports":
            categories.push("beach");
            break;
        case "city":
            categories.push("city");
            break;
        case "nature":
        case "landscapes":
            categories.push("nature");
            break;
        case "prices":
            if (objectKey != "flightOrigin") categories.push("prices");
            if (objectKey == "pricesOverall") {
                categories.push("essentials");
            }
            break;
        case "":
            categories.push(objectKey == "distance" ? "other" : "essentials");
            break;
        default:
            if (objectKey == "citySize") categories.push("city");
            else if (objectKey != "visaOrigin") categories.push("other");
    }
    return categories;
};

const updateApiCall = (apiCall: any) => {
    const aggregatedKeys = [
        "nature",
        "city",
        "beach",
        "beachSports",
        "landscapes",
        "scenes"
    ];
    for (let key of aggregatedKeys) {
        const categoryKeys = keys(apiCall[key] || {});
        if (categoryKeys.length >= 1) {
            apiCall[key] = categoryKeys;
        } else {
            delete apiCall[key];
        }
    }
    if (apiCall.suitability) {
        apiCall.suitability = [apiCall.suitability];
    }
    if (apiCall.continent) {
        apiCall.continents = [apiCall.continent];
    }
    if (apiCall.prices?.flightTickets) {
        apiCall.prices[
            "flightTickets" + firstCapitalCase(apiCall.prices.flightOrigin)
        ] = apiCall.prices?.flightTickets;
        delete apiCall.prices.flightTickets;
    }
    delete apiCall.prices.flightOrigin;

    if (apiCall.other?.visa) {
        if (apiCall.other.visaOrigin == "eu") {
            apiCall.other.visaEu = apiCall.other.visa;
        } else {
            apiCall.other.visaUsa = apiCall.other.visa;
        }
        delete apiCall.other.visa;
    }

    delete apiCall.other.visaOrigin;

    apiCall.important = [];
};

export const processValues = (values: SearchFormInputs) => {
    const apiCall: any = {};
    let totalFilters = 0;
    const searchCategoriesMap = {
        essentials: 0,
        weather: 0,
        beach: 0,
        nature: 0,
        city: 0,
        prices: 0,
        other: 0
    };
    for (let categoryKey in values) {
        let category = categoryKey;
        let valueObject = values[categoryKey];
        if (!isObject(valueObject)) {
            valueObject = { [categoryKey]: valueObject };
            category = "";
        }
        for (let objectKey in valueObject) {
            const value = valueObject[objectKey];
            const transformedValue = transformValue(value, category, objectKey);
            if (transformedValue === undefined) {
                continue;
            }
            const searchCategories = getSearchCategory(category, objectKey);
            if (category) {
                apiCall[category] = apiCall[category] || {};
                apiCall[category][objectKey] = transformedValue;
            } else {
                apiCall[objectKey] = transformedValue;
            }
            totalFilters += 1;
            for (let searchCategory of searchCategories) {
                searchCategoriesMap[searchCategory] += 1;
            }
        }
    }
    updateApiCall(apiCall);
    return { apiCall, searchCategories: searchCategoriesMap, totalFilters };
};
